// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "async-" + "hogwarts_dash_monaco" + ".js";
};